import React from "react";
import HeaderFour from "../../components/Header/HeaderFour";
import TestimonialMain from "./TestimonialMain";
import Footer from "../../components/Footer";

const Testimonial = () => {
  return (
    <>
      <HeaderFour />
      <TestimonialMain />
      <Footer />
    </>
  );
};

export default Testimonial;
